/**
 * @module 同意ダイアログ共通コンポーネント
 */
var mixin = {
  data() {
    return {
      show: false,
      type1: 1, // いずれ定数一覧に移動
      type2: 2,
      type3: 3,
      type4: 4,
    };
  },
  created() {
    this.$mount();
    const id = document.getElementById('agreement-dialog');
    if (id === null) {
      document.body.appendChild(this.$el);
      this.show = true;
    }
  },
  watch: {
    $browserBack(newVal, oldVal) {
      if (newVal && !oldVal) {
        this.close();
      }
    },
    $route() {
      this.close();
    },
  },
  methods: {
    close() {
      this.show = false;
      setTimeout(() => {
        if (document.body.contains(this.$el)) document.body.removeChild(this.$el);
        this.$destroy();
      }, 200);
    },
  },
};

export default {
  mixins: [mixin],
  props: {
    title: {
      type: String,
      required: true,
    },
    labelList: {
      type: Array,
      required: false,
    },
    text: {
      type: String,
      required: true,
    },
    cancelName: {
      type: String,
      required: true,
    },
    okBtnName: {
      type: String,
      required: true,
    },
    cancelAction: {
      type: Function,
      required: true,
    },
    okAction: {
      type: Function,
      required: true,
    },
    cancelButtonType: {
      type: Number,
      required: false,
      default: 0,
    },
    okButtonType: {
      type: Number,
      required: false,
      default: 1,
    },
    contentClass: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      okLoadFlag: false,
      cancelLoadFlag: false,
    };
  },
  /** @type {Methods} */
  methods: {
    /**
     * OKボタン押下時処理
     */
    ok() {
      this.okLoadFlag = true;
      this.okAction();
      this.close();
      this.okLoadFlag = false;
    },
    /**
     * キャンセルボタンを押下時処理
     */
    cancel() {
      this.cancelLoadFlag = true;
      this.cancelAction();
      this.close();
      this.cancelLoadFlag = false;
    },
  },
};
